import React from 'react';

import PropTypes from 'prop-types';
import styled from 'styled-components';

const StyledProductName = styled.p`
  display: block;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  margin-bottom: 6px;
  color: ${({ theme }) => theme.colors.gridProductCardProductNameTextColor};
`;

function ProductName({ children, isUnavailable = false }) {
  return (
    <StyledProductName
      isUnavailable={isUnavailable}
      data-qa-automation="gridSetsProdName"
      data-autotag="grid-product-name"
    >
      {children}
    </StyledProductName>
  );
}

ProductName.propTypes = {
  children: PropTypes.node.isRequired,
  isUnavailable: PropTypes.bool,
};

export default ProductName;
